<template>
  <v-row v-if="lodash.isEmpty(prescriptions)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem receitas
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <v-row dense v-for="(prescription, index) in prescriptions" :key="prescription.id">
        <v-col>
          <PrescriptionListItem
            :attendance="attendance"
            :prescription="prescription"
            :index="index"
            :refreshList="refreshList"
            :allowEdit="allowEdit"
            :allowDelete="allowDelete"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import PrescriptionListItem from "@/components/prescription/list/item.vue";

  export default {
    name: "PrescriptionList",
    props: {
      attendance: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      PrescriptionListItem,
    },
    mounted(){
      this.refreshList();
    },
    apollo: {
      prescriptions: {
        query: require("@/graphql/prescription/prescriptions.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.prescriptions, ["createdAt"], ["asc"]);
        },
        pollInterval: 200000,
      },
    },
    methods: {
      async refreshList() {
        await this.$apollo.queries.prescriptions.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
